import { motion, useReducedMotion } from 'framer-motion';

const MAGIC_STAGES = [
  { id: 'brief', label: 'Brief' },
  { id: 'design_system', label: 'Design' },
  { id: 'structure', label: 'Structure' },
  { id: 'content', label: 'Content' },
  { id: 'assets', label: 'Assets' },
  { id: 'build', label: 'Build' },
  { id: 'review', label: 'Review' },
  { id: 'deploy', label: 'Deploy' },
];

export default function GlassNav({ viewStage, currentStage, completedStages, onStageClick, disabled, stages }) {
  const prefersReducedMotion = useReducedMotion();
  const STAGES = stages || MAGIC_STAGES;
  const currentIdx = STAGES.findIndex(s => s.id === currentStage);

  return (
    <div className="glass-nav rounded-full flex items-center" style={{ padding: '4px' }}>
      <div className="flex items-center gap-0.5 px-2">
        {STAGES.map((stage, idx) => {
          const isCompleted = (completedStages || []).includes(stage.id);
          const isViewed = stage.id === viewStage;
          const isLocked = disabled || (idx > currentIdx && !isCompleted);
          const isAccessible = !isLocked;
          const isPast = isCompleted && !isViewed;

          return (
            <button
              key={stage.id}
              onClick={() => isAccessible && onStageClick(stage.id)}
              disabled={isLocked}
              className="relative flex items-center gap-1.5 rounded-full transition-all duration-200"
              style={{
                padding: '5px 16px',
                cursor: isLocked ? 'not-allowed' : 'pointer',
                background: isViewed ? 'rgba(184, 204, 223, 0.1)' : 'transparent',
              }}
              data-testid={`stage-${stage.id}`}
            >
              {/* Active dot with glow */}
              {isViewed && (
                <motion.div
                  layoutId="stage-dot"
                  className="w-1.5 h-1.5 rounded-full"
                  style={{
                    background: 'var(--orbis-blue)',
                    boxShadow: '0 0 8px rgba(184, 204, 223, 0.5)',
                  }}
                  transition={prefersReducedMotion ? { duration: 0 } : { type: 'spring', stiffness: 400, damping: 30 }}
                />
              )}
              {/* Completed dot (no glow) */}
              {isPast && !isViewed && (
                <div
                  className="w-1.5 h-1.5 rounded-full"
                  style={{ background: 'rgba(184, 204, 223, 0.4)' }}
                />
              )}
              <span style={{
                fontSize: '13px',
                fontWeight: isViewed ? 500 : 400,
                fontFamily: 'var(--orbis-font)',
                color: isViewed
                  ? 'var(--orbis-blue)'
                  : isPast
                    ? 'var(--orbis-t3)'
                    : isLocked
                      ? 'var(--orbis-t4)'
                      : 'var(--orbis-t3)',
                transition: 'color 150ms ease',
              }}>
                {stage.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
